import { useEffect, useState } from 'react';
import Footer from '../components/Footer/FooterSection';
import HeaderTwo from '../components/HeaderTwo/HeaderTwoSection';
import ProductDisplay from '../components/ProductDisplay/ProductDisplaySection';
import '../styles/productdetail.scss';
import {
 ProductDetailProps,
 starsNuser,
} from '../interface/interfaces';
import ProductData from '../components/ProductData/ProductDataSection';
import CustomHistory from '../components/customHistory/CustomHistorySection';
import SkeletonLoader from '../components/SkeletonLoaders/DefaultLoader';
import { useParams } from 'react-router-dom';
import { loadProductDetails, loadUserReviews } from '../api/requests';
import { useNotification } from '../context/NotificationContext';

const ProductDetail = () => {
 const { productid } = useParams();
 const { notify } = useNotification();

 const [productDetails, setProductDetails] =
  useState<ProductDetailProps | null>(null);
 const [isPageLoading, setPageLoader] = useState(false);

 function getStarDistribution(
  reviews: { starRatings: { stars: number } }[],
 ): starsNuser[] {
  const starMap: { [key: number]: number } = {
   1: 0,
   2: 0,
   3: 0,
   4: 0,
   5: 0,
  };

  reviews.forEach((review) => {
   const stars = review.starRatings.stars;
   if (stars >= 1 && stars <= 5) {
    starMap[stars]++;
   }
  });

  const result: starsNuser[] = Object.entries(starMap).map(
   ([stars, numberOfUsers]) => ({
    stars: Number(stars),
    numberOfUsers,
   }),
  );

  return result;
 }

 useEffect(() => {
  const func = async () => {
   if (!productid) {
    // Go Not Found
    notify.error('Invalid link, please reload!');
    return;
   }

   try {
    setPageLoader(true);
    const [productDetails, userReview] = await Promise.all([
     loadProductDetails(productid),
     loadUserReviews(productid, 1, 100),
    ]);

    let starNuser = getStarDistribution(userReview);

    productDetails.reviewDetails.userReviews = userReview;
    productDetails.reviewDetails.starsNusers = starNuser;

    setProductDetails(productDetails);
   } catch (error: any) {
    if (error.status === 404) {
     // Go to not found page
     console.log('Page not found');
    } else {
     notify.error(error.message);
    }
   } finally {
    setPageLoader(false);
   }
  };

  func();

  // eslint-disable-next-line
 }, []);

 return (
  <>
   <HeaderTwo></HeaderTwo>

   <CustomHistory></CustomHistory>

   <div className="productdetails content">
    {!isPageLoading && productDetails && (
     <div className="animate__animated animate__fadeIn animate__fast">
      <ProductDisplay details={productDetails}></ProductDisplay>
      <ProductData details={productDetails}></ProductData>
     </div>
    )}

    {isPageLoading && (
     <>
      <SkeletonLoader count={4}></SkeletonLoader>
     </>
    )}
   </div>

   <Footer></Footer>
  </>
 );
};

export default ProductDetail;
